import { createFileRoute } from '@tanstack/react-router';

import SuccessPage from '../../../components/pages/SuccessPage';

export const Route = createFileRoute('/tracker/$trackerId/success')({
	component: SuccessPage,
});
